import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Survey: {
    title: "Anket 1",
    description: "",
    questions: [],
    headerBackground: null,
    footerBackground: null,
  },
  inputFocus: false,
  SelectedQuestions: -1,
};

export const SurveySlice = createSlice({
  name: "StatusSlice",
  initialState,
  reducers: {
    SetSurvey: (state, action) => {
      state.Survey = action.payload; //Change Survey
    },
    SurveyAddItem: (state, action) => {
      state.Survey.questions.push(action.payload);
    },
    SetInputFocus: (state, action) => {
      state.inputFocus = action.payload;
    },
    SetSelectedQuestions: (state, action) => {
      state.SelectedQuestions = action.payload;
    },

    DeleteQuestions: (state, action) => {
      state.SelectedQuestions = -1;
      if (action.payload > -1) {
        state.Survey.questions.splice(action.payload, 1);
      }
    },

    MoveQuestions: (state, action) => {
      //
      state.SelectedQuestions = -1;
      //
      var element = state.Survey.questions[action.payload.index];
      state.Survey.questions.splice(action.payload.index, 1);
      state.Survey.questions.splice(action.payload.newindex, 0, element);
    },

    SurveyAddItemSpecifixIndex: (state, action) => {
      state.Survey.questions.splice(
        action.payload.index,
        0,
        action.payload.item
      );
    },

    EditSurveyTitle: (state, action) => {
      state.Survey.title = action.payload;
    },
    EditSurveyHeaderBackground: (state, action) => {
      state.Survey.headerBackground = action.payload;
    },
    EditSurveyFooterBackground: (state, action) => {
      state.Survey.footerBackground = action.payload;
    },

    EditSurveyDescription: (state, action) => {
      state.Survey.description = action.payload;
    },
    EditSurveyRequired: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].required = action.payload;
    },
    EditQuestionsTitle: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].title = action.payload;
    },
    // EditQuestionsId: (state, action) => {
    //   state.Survey.questions[action.payload.index].question_id =
    //     action.payload.id;
    // },
    EditQuestionsDescription: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].description =
        action.payload;
    },
    EditQuestionsEmoji: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].emoji =
        action.payload;
    },
    EditQuestionsFirstEmojiUrl: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].firstEmojiUrl =
        action.payload;
    },
    EditQuestionsSecondEmojiUrl: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].secondEmojiUrl =
        action.payload;
    },
    EditOptions: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].options[
        action.payload.index
      ] = action.payload.value;
    },
    AddOptions: (state, action) => {
      state.Survey.questions[state.SelectedQuestions].options.push(
        action.payload
      );
    },
    DeleteOptions: (state, action) => {
      if (action.payload > -1) {
        state.Survey.questions[state.SelectedQuestions].options.splice(
          action.payload,
          1
        );
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  SetSurvey,
  SurveyAddItem,
  SetSelectedQuestions,
  EditQuestionsTitle,
  // EditQuestionsId,
  EditQuestionsDescription,
  EditQuestionsEmoji,
  EditOptions,
  AddOptions,
  DeleteOptions,
  EditSurveyTitle,
  EditSurveyDescription,
  EditSurveyHeaderBackground,
  EditSurveyFooterBackground,
  DeleteQuestions,
  MoveQuestions,
  EditSurveyRequired,
  SurveyAddItemSpecifixIndex,
  SetInputFocus,
  EditQuestionsFirstEmojiUrl,
  EditQuestionsSecondEmojiUrl
} = SurveySlice.actions;

export default SurveySlice.reducer;
